/**
 *
 * @module oneTimePasscodeRequestReason
 * @see https://github.bamtech.co/sdk-doc/spec-sdk/blob/master/specs/feature_overviews/identity-bam.md#one-time-passcodes
 *
 */

/* eslint new-cap: 'off' */


/**
 *
 * @typedef OneTimePasscodeRequestReason
 * @type {Object}
 * @since 3.9.0
 * @desc Enumerates the known keys for one time passcode request reason.
 * @example OneTimePassCodeRequestReason.authenticate // 'Login'
 *
 * @property {String} authenticate - The "Login" key.
 * @property {String} forgotPassword - The "ForgotPassword" key.
 *
 */

/**
 *
 * @enum
 * @type {OneTimePasscodeRequestReason}
 *
 */
export default {
    /**
     *
     * @access public
     * @type {String}
     *
     */
    authenticate: 'Login',
    /**
     *
     * @access public
     * @type {String}
     *
     */
    forgotPassword: 'ForgotPassword'
};



// WEBPACK FOOTER //
// ./src/services/identity/bam/oneTimePasscodeRequestReason.js